import { render } from "./eventRegistration.vue?vue&type=template&id=6b8d7f65&scoped=true"
import script from "./eventRegistration.vue?vue&type=script&lang=js"
export * from "./eventRegistration.vue?vue&type=script&lang=js"

import "./eventRegistration.vue?vue&type=style&index=0&id=6b8d7f65&lang=scss&scoped=true"
import "./eventRegistration.vue?vue&type=style&index=1&id=6b8d7f65&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8d7f65"]])

export default __exports__